<template>
  <v-dialog
    v-model="showDialog"
    no-click-animation
    persistent
    width="500"
    :transition="false"
  >
    <v-card>
      <v-card-title>{{ $t('globals.confirmTitle') }}</v-card-title>
      <v-card-text>{{ text }}</v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="confirmDialog = false"
        >
          {{ $t('globals.cancelButton') }}
        </v-btn>
        <v-btn
          class="primary"
          @click="confirmed = true;confirmDialog = false"
        >
          {{ $t('globals.confirmButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ""
    },
    version: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    confirmed: false
  }),
  computed: {
    confirmDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("closeConfirmDialog", this.confirmed);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
